export type { VoltraBaseProps } from './baseProps'
export * from './createVoltraComponent.js'
